interface WorkExperiences {
  id: string
  industryTags: string[]
  financialTags: string[]
  softwareTags: string[]
}

interface ExternalProjects {
  id: string
  industryTags: string[]
  financialTags: string[]
  softwareTags: string[]
}

export const retrieveTagsFromEntities = (
  tagTypes: string,
  expertTags: string[] = [],
  workExperiences: WorkExperiences[] = [],
  externalProjects: ExternalProjects[] = []
) => {
  const workExperiencesTags = workExperiences?.flatMap((work) => work[tagTypes as keyof WorkExperiences]) || []
  const externalProjectsTags = externalProjects?.flatMap((project) => project[tagTypes as keyof ExternalProjects]) || []
  const mergedTags = [...workExperiencesTags, ...externalProjectsTags, ...(expertTags || [])]

  const tagArray = Array.from(new Set(mergedTags)) || []

  return tagArray || [];
}
